module.exports = __webpack_public_path__ + "static/media/7.2c8c55e0.png";